import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {ServiceManagementRequirement, ServiceManagementRequirementInput} from './service-management-requirement.model';

export const loadServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] Load ServiceManagementRequirements',
  props<{ serviceManagementRequirements: ServiceManagementRequirement[] }>()
);

export const addServiceManagementRequirement = createAction(
  '[ServiceManagementRequirement/API] Add ServiceManagementRequirement',
  props<{ serviceManagementRequirement: ServiceManagementRequirement }>()
);

export const upsertServiceManagementRequirement = createAction(
  '[ServiceManagementRequirement/API] Upsert ServiceManagementRequirement',
  props<{ serviceManagementRequirement: ServiceManagementRequirement }>()
);

export const addServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] Add ServiceManagementRequirements',
  props<{ serviceManagementRequirements: ServiceManagementRequirement[] }>()
);

export const upsertServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] Upsert ServiceManagementRequirements',
  props<{ serviceManagementRequirements: ServiceManagementRequirement[] }>()
);

export const updateServiceManagementRequirement = createAction(
  '[ServiceManagementRequirement/API] Update ServiceManagementRequirement',
  props<{ serviceManagementRequirement: Update<ServiceManagementRequirement> }>()
);

export const updateServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] Update ServiceManagementRequirements',
  props<{ serviceManagementRequirements: Update<ServiceManagementRequirement>[] }>()
);

export const deleteServiceManagementRequirement = createAction(
  '[ServiceManagementRequirement/API] Delete ServiceManagementRequirement',
  props<{ id: string }>()
);

export const deleteServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] Delete ServiceManagementRequirements',
  props<{ ids: string[] }>()
);

export const clearServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] Clear ServiceManagementRequirements'
);

// CUSTOM
export const createServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] create ServiceManagementRequirement',
  props<{ input: ServiceManagementRequirementInput }>()
);


export const updateServiceRequirementDescriptionMutation = createAction(
  '[ServiceRequirement/API] Update ServiceManagementRequirement Description',
  props<{ input: any }>()
);

export const addServiceRequirementAlternativeMutation = createAction(
  '[ServiceRequirement/API] add ServiceManagementRequirement Alternative',
  props<{ input: any }>()
);

export const removeServiceRequirementAlternativeMutation = createAction(
  '[ServiceRequirement/API] remove ServiceManagementRequirement Alternative',
  props<{ requirementUniqueId: string }>()
);

export const removeServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] remove ServiceManagementRequirement',
  props<{ serviceRequirementUniqueId: string, id: string }>()
);


export const getServiceManagementRequirements = createAction(
  '[ServiceManagementRequirement/API] get ServiceManagementRequirement',
  props<{ serviceUniqueId: string }>()
);
